export default function CommonTable({
  columns,
  data,
  page,
  totalPage,
  onPageChange,
}) {
  return (
    <>
      {/* Pagination */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "10px",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        <span style={{ fontSize: "14px" }}>
          Page: {page} / {totalPage}
        </span>

        {/* Prev */}
        <button
          disabled={page === 1}
          onClick={() => onPageChange(page - 1 )}
          style={{
            padding: "6px 12px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            background: page === 1 ? "#eee" : "#031634",
            color: page === 1 ? "#999" : "white",
            cursor: page === 1 ? "not-allowed" : "pointer",
          }}
        >
          Prev
        </button>

        {/* Next */}
        <button
          disabled={page >= totalPage}
          onClick={() => onPageChange(page + 1)}
          style={{
            padding: "6px 12px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            background: page + 1 >= totalPage ? "#eee" : "#031634",
            color: page + 1 >= totalPage ? "#999" : "white",
            cursor: page + 1 >= totalPage ? "not-allowed" : "pointer",
          }}
        >
          Next
        </button>
      </div>
      {/* Table */}
      <table
        style={{
          width: "100%",
          background: "white",
          borderRadius: "8px",
          borderCollapse: "collapse",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <thead>
          <tr style={{ background: "#000", color: "white" }}>
            <th
              style={{
                padding: "10px",
                borderBottom: "1px solid #ddd",
                textAlign: "left",
              }}
            >
              SI No.
            </th>

            {columns.map((col) => (
              <th
                key={col.key}
                style={{
                  padding: "10px",
                  borderBottom: "1px solid #ddd",
                  textAlign: "left",
                }}
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={row._id || rowIndex}>
              {/* serial index */}
              <td
                style={{
                  padding: "10px",
                  borderBottom: "1px solid #eee",
                  fontSize: "14px",
                }}
              >
                {(page - 1) * 20 + (rowIndex + 1)}

              </td>

              {columns.map((col) => (
                <td
                  key={col.key}
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #eee",
                    fontSize: "14px",
                  }}
                >
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

    </>
  );
}
